import React from 'react';
import {
  KeyboardAvoidingView,
  ScrollView,
  Platform,
  StyleSheet,
} from 'react-native';
import { KeyboardProvider, KeyboardAwareScrollView } from "react-native-keyboard-controller";
import { isWeb } from '../../utils/Helper';

const KeyboardAvoidingWrapper = ({ children, style, keyboardVerticalOffset = 0}) => {

  if (isWeb()) {
    return <>{children}</>;
  }

  return (
    <KeyboardProvider>
        {children}
    </KeyboardProvider>
  );
};


export default KeyboardAvoidingWrapper;